<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>
    <!-- 1 -->
    <input-form-penilaian-kplh :tables="tableInput.inputForm1" :listInput="listInput.inputForm1" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.kplhStore.is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm2" :listInput="listInput.inputForm2" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.kplhStore.is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm3" :listInput="listInput.inputForm3" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.kplhStore.is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm4" :listInput="listInput.inputForm4" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.kplhStore.is_preview" />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFormPenilaianKplh from '../../components/forms/input-form-penilaian-kplh.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFormPenilaianKplh,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'J. KEJADIAN, KECELAKAAN & PENYELIDIKAN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm2: [
          {
            name: 'K. STATISTIK KPLH',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm3: [
          {
            name: 'L. AUDIT INTERNAL',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm4: [
          {
            name: 'M. TINJAUAN MANAJEMEN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'form',
            name:
              'Lampirkan prosedur terkait kecelakaan dan penyelidikan kecelakaan',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_j_1',
            inputStore: 'note_j_1',
            fileStore: 'attachment_j_1',
            tooltipText: 'Prosedur meliputi: Pelaporan awal, pengamanan lokasi dan barang bukti di tempat kejadian, tim penyelidikan, tahapan penyelidikan, tahap pemantauan, dan tahap evaluasi penyelidikan kecelakaan',
            internalNoteStore: 'internal_note_j_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan hasil penyelidikan kecelakaan (minimal 2)',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_j_2',
            inputStore: 'note_j_2',
            fileStore: 'attachment_j_2',
            tooltipText: '2 salinan hasil penyelidikan kecelakaan yang sesuai dengan prosedur',
            internalNoteStore: 'internal_note_j_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan bukti kompetensi petugas yang melakukan penyelidikan kecelakaan',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_j_3',
            inputStore: 'note_j_3',
            fileStore: 'attachment_j_3',
            tooltipText: 'Kompetensi petugas yang melakukan penyelidikan kecelakaan dari eksternal (misalkan BNSP)',
            internalNoteStore: 'internal_note_j_3',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan bukti sosialisasi hasil penyelidikan kecelakaan kepada pekerja',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_j_4',
            inputStore: 'note_j_4',
            fileStore: 'attachment_j_4',
            tooltipText: 'Bukti sosialisasi kepada pekerja dengan keterangan nama insiden, waktu, dan tempat serta rekomendasi hasil investigasinya',
            internalNoteStore: 'internal_note_j_4',
          },
        ],
        inputForm2: [
          {
            type: 'form',
            name: 'Lampirkan laporan kinerja KPLH perusahaan yang terakhir',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_k_1',
            inputStore: 'note_k_1',
            fileStore: 'attachment_k_1',
            tooltipText: 'kinerja KPLH meliputi Jumlah Man Power, Man Hour, Number of Incident, Frekuensi Rate, Severity Rate dan leading indikator dengan pencapaian >75%',
            internalNoteStore: 'internal_note_k_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan penghargaan dalam bidang KPLH yang pernah di dapatkan perusahaan',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_k_2',
            inputStore: 'note_k_2',
            fileStore: 'attachment_k_2',
            tooltipText: 'Terdapat 1 penghargaan',
            internalNoteStore: 'internal_note_k_2',
          },
        ],
        inputForm3: [
          {
            type: 'form',
            name: 'Lampirkan prosedur audit yang dimiliki perusahaan',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_l_1',
            inputStore: 'note_l_1',
            fileStore: 'attachment_l_1',
            tooltipText: 'Prosedur meliputi: Ruang lingkup, frekuensi, metodologi, kompetensi auditor, tanggung jawab, dan persyaratan pelaksanaan audit, serta pelaporan hasil audit',
            internalNoteStore: 'internal_note_l_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan program audit tahunan yang terakhir',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_l_2',
            inputStore: 'note_l_2',
            fileStore: 'attachment_l_2',
            tooltipText: 'Meliputi audit internal dan / atau eksternal serta tindak lanjut temuan auditnya',
            internalNoteStore: 'internal_note_l_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan laporan audit (eksternal / internal) yang terakhir',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_l_3',
            inputStore: 'note_l_3',
            fileStore: 'attachment_l_3',
            tooltipText: 'Salinan laporan audit internal dan / atau eksternal berikut rencana tindak lanjutnya',
            internalNoteStore: 'internal_note_l_3',
          },
        ],
        inputForm4: [
          {
            type: 'form',
            name: 'Lampirkan prosedur terkait tinjauan manajemen',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_m_1',
            inputStore: 'note_m_1',
            fileStore: 'attachment_m_1',
            tooltipText: 'Prosedur meliputi: - Pelaksanaan (periode, pelaksana, dan peserta) - minimum agenda / materi, poin-poin risalah / notulensi - pendistribusian materi dan notulensi, tindak lanjut',
            internalNoteStore: 'internal_note_m_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan bukti pelaksanaan rapat tinjauan manajemen yang terakhir',
            subname: 'Kritis',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_m_2',
            inputStore: 'note_m_2',
            fileStore: 'attachment_m_2',
            tooltipText: 'melampirkan daftar hadir & materi sesuai prosedur',
            internalNoteStore: 'internal_note_m_2',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan risalah/notulensi hasil rapat tinjauan manajemen yang terakhir',
            subname: 'Kritis',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_m_3',
            inputStore: 'note_m_3',
            fileStore: 'attachment_m_3',
            tooltipText: 'Risalah mencakup:  Tinjauan kebijakan, kinerja keselamatan, sumber daya, dan hal lainnya yang bersifat strategis',
            internalNoteStore: 'internal_note_m_3',
          },
        ],
      },
    }
  },
  watch: {
    '$store.state.kplhStore.penilaian_grup1_11'(value, oldValue) {
      this.$store.commit('kplhStore/CALCULATION_3')
    },
    '$store.state.kplhStore.penilaian_grup2_11'(value, oldValue) {
      this.$store.commit('kplhStore/CALCULATION_3')
    },
    '$store.state.kplhStore.penilaian_grup2_12'(value, oldValue) {
      this.$store.commit('kplhStore/CALCULATION_3')
    },
    '$store.state.kplhStore.penilaian_grup3_11'(value, oldValue) {
      this.$store.commit('kplhStore/CALCULATION_3')
    },
  },
  methods: {
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi2' })
    },
    goNext() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'selesai' })
      this.$store.commit('kplhStore/PROCESSING_KPLH_FOR_DRAFT', {
        onSuccess: () => {
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'end_step',
            value: true,
          })

        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
